var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3113_20313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9473 31.0279C7.40728 31.0279 0.467285 24.0879 0.467285 15.5479C0.467285 7.00787 7.40728 0.0678711 15.9473 0.0678711C24.4873 0.0678711 31.4273 7.00787 31.4273 15.5479C31.4273 24.0879 24.4873 31.0279 15.9473 31.0279ZM15.9473 1.94787C8.44728 1.94787 2.34729 8.04787 2.34729 15.5479C2.34729 23.0479 8.44728 29.1479 15.9473 29.1479C23.4473 29.1479 29.5473 23.0479 29.5473 15.5479C29.5473 8.04787 23.4473 1.94787 15.9473 1.94787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3773 18.2478C21.9573 17.1878 17.6673 12.5778 15.5573 8.89775C13.2773 4.92775 12.9973 1.22775 12.9873 1.07775L14.8573 0.947754C14.8973 1.50775 16.0273 14.5678 30.6173 16.3978L30.3873 18.2578L30.3773 18.2478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0674 29.968C17.0274 29.408 15.8974 16.348 1.30737 14.518L1.53737 12.658C9.95737 13.718 14.2474 18.328 16.3574 22.008C18.6374 25.978 18.9174 29.678 18.9274 29.828L17.0574 29.958L17.0674 29.968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3113_20313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.96,
    height: 30.96,
    fill: "white",
    transform: "translate(0.467285 0.0678711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenis);
export default __webpack_public_path__ + "static/media/tenis.49850d69cc5405851fa32cc73fb2b821.svg";
export { ForwardRef as ReactComponent };